function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("path", {
  d: "M20 6.061c0-.018 0-.036-.006-.053s0-.031-.006-.047L18.72.387c0-.013-.009-.024-.013-.037A.43.43 0 0018.69.3a.468.468 0 00-.026-.048c-.007-.011-.012-.023-.02-.034a.449.449 0 00-.04-.049l-.02-.023a.46.46 0 00-.05-.042l-.023-.017a.487.487 0 00-.058-.032l-.026-.013a.472.472 0 00-.065-.02l-.026-.008a.466.466 0 00-.072-.007H1.733a.514.514 0 00-.07.007l-.024.007a.506.506 0 00-.069.021l-.02.01a.5.5 0 00-.064.034L1.47.099a.508.508 0 00-.056.046l-.016.018a.454.454 0 00-.044.053l-.018.031a.483.483 0 00-.028.051.429.429 0 00-.017.05c0 .013-.01.024-.013.037L.011 5.959a.45.45 0 00-.006.046.535.535 0 00-.006.054 2.484 2.484 0 00.656 1.686v11.429a.821.821 0 00.82.82h4.918a.821.821 0 00.82-.82v-6.721h5.574v6.721a.821.821 0 00.82.82h4.918a.821.821 0 00.82-.82V7.745a2.485 2.485 0 00.656-1.686zm-4.3-.488a.492.492 0 00-.492.492 1.411 1.411 0 11-2.819 0 .492.492 0 00-.984 0 1.411 1.411 0 11-2.82 0 .492.492 0 00-.984 0 1.411 1.411 0 11-2.819 0 .492.492 0 00-.984 0 1.409 1.409 0 11-2.816.039L2.147.983h15.7l1.165 5.121a1.409 1.409 0 11-2.817-.039.492.492 0 00-.495-.491zm-1.934 13.442v-6.721a.82.82 0 00-.82-.82h-5.9a.82.82 0 00-.82.82v6.721h-4.59V8.4a2.325 2.325 0 00.754.127 2.346 2.346 0 013.8 0 2.347 2.347 0 013.8 0 2.347 2.347 0 013.8 0 2.346 2.346 0 013.8 0 2.322 2.322 0 00.754-.127v10.619z"
});

var SvgStore = function SvgStore(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return (
    /*#__PURE__*/
    React.createElement("svg", _extends({
      width: 20,
      height: 20,
      ref: svgRef
    }, props), title ?
    /*#__PURE__*/
    React.createElement("title", null, title) : null, _ref2)
  );
};

var ForwardRef =
/*#__PURE__*/
React.forwardRef(function (props, ref) {
  return (
    /*#__PURE__*/
    React.createElement(SvgStore, _extends({
      svgRef: ref
    }, props))
  );
});
export default __webpack_public_path__ + "static/media/Store.75a63f0a.svg";
export { ForwardRef as ReactComponent };